import Modal from 'antd/lib/modal/Modal';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Typography from 'antd/lib/typography';
import React from 'react';
import Radio from 'antd/lib/radio';
import Space from 'antd/lib/space';
import { useLocalStorage } from '../../../domain/useLocalStorage';
import { useAuth } from '../../../domain/auth/useAuth';

export interface IDownloadNominationCsvFormData {
    columnsPreset?: 'default' | 'detailed';
}

interface IDownloadNominationCsvModal {
    onClose: Function;
    onSubmit: (data: IDownloadNominationCsvFormData) => void;
}

const STORAGE_KEY = 'nomination-csv-download-options';

const DEFAULT_FORM_VALUE: IDownloadNominationCsvFormData = {
    columnsPreset: 'default',
};

export const DownloadNominationCsvModal = ({ onClose, onSubmit }: IDownloadNominationCsvModal) => {
    const [form] = Form.useForm<IDownloadNominationCsvFormData>();
    const auth = useAuth()!;
    const [options, setOptions] = useLocalStorage<IDownloadNominationCsvFormData>(`${STORAGE_KEY}-${auth.user?.user_id}`, DEFAULT_FORM_VALUE);

    const handleClose = () => onClose();

    const handleConfirm = (formData: IDownloadNominationCsvFormData) => {
        setOptions({ ...options, ...formData });
        onSubmit(formData);
    };

    return (
        <Modal
            open
            title="Download CSV"
            destroyOnHidden
            closeIcon
            onCancel={handleClose}
            styles={{
                footer: {
                    borderTop: 'none',
                    padding: '0 24px 24px 24px',
                },
            }}
            footer={[
                <Button key="modal-cancel" onClick={handleClose}>
                    Cancel
                </Button>,
                <Button key="download-csv-confirm" type="primary" onClick={form.submit}>
                    Download
                </Button>,
            ]}
        >
            <Form
                form={form}
                name="download-site-csv-form"
                preserve={false}
                layout="vertical"
                onFinish={handleConfirm}
                style={{ marginTop: '12px' }}
                initialValues={options}
            >
                <>
                    <Space direction="vertical" size={0} style={{ marginBottom: '24px' }}>
                        <Typography.Text strong style={{ fontSize: '16px' }}>
                            CSV Download Options
                        </Typography.Text>
                        <Typography.Text>Options will be set as default</Typography.Text>
                    </Space>
                    <Form.Item name="columnsPreset">
                        <Radio.Group>
                            <Space direction="vertical" size={0}>
                                <Typography.Text strong>Columns to Download</Typography.Text>
                                <Radio value="detailed">
                                    <Typography.Text strong>Download All Nomination Columns</Typography.Text>
                                </Radio>
                                <Typography.Text type="secondary" style={{ marginLeft: '24px' }}>
                                    This will increase load time
                                </Typography.Text>

                                <Radio value="default">
                                    <Typography.Text strong>Download Current View</Typography.Text>
                                </Radio>
                                <Typography.Text type="secondary" style={{ marginLeft: '24px' }}>
                                    Download columns shown in DRMS UI
                                </Typography.Text>
                            </Space>
                        </Radio.Group>
                    </Form.Item>
                </>
            </Form>
        </Modal>
    );
};
